import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { batch_get_all } from "../../util/Apiendpoits";
import { getWithTokenAPI } from "../../util/Api";
import { FiEye } from "react-icons/fi";
import DynamicTable from "../ReusableComponent/DynamicTable";
import { FiFileText, FiVideo, FiCalendar } from "react-icons/fi";

import { useNavigate } from "react-router-dom";
import TableSkeleton from "../ReusableComponent/TableSkeleton";
const TotalBatches = () => {
  const { token, userId } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  // --- State for Table ---
  const [loading, setLoading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);

  // --- Fetch Data ---
  const fetchBatchList = async () => {
    try {
      setLoading(true);
      let queryUrl = `${batch_get_all}${userId}`;
      if (search) {
        queryUrl += `&search=${search}`;
      }
      const res = await getWithTokenAPI(token, queryUrl);

      if (res?.statusCode === 200) {
        const formattedData = res.data.data.map((item) => ({
          ...item,
          id: item._id,
        }));
        setBatches(formattedData);
      } else {
        setBatches([]);
      }
    } catch (error) {
      console.error("Batch list API error:", error);
      setBatches([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchBatchList();
    }, 500); // Wait for 500ms before calling the API

    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  const getColumns = () => [
    {
      key: "batchName",
      label: "Batch Name",
      render: (row) => <strong>{row.testBatchName}</strong>,
    },

    {
      key: "examType",
      label: "Exam Type",
      render: (row) => row.examType?.value || "N/A",
    },

    {
      key: "subExamType",
      label: "Sub Exam Type",
      render: (row) => row.subexamType?.value || "N/A",
    },
    {
      key: "syllabus",
      label: "Syllabus",
      render: (row) => row.syllabus || "N/A",
    },
    {
      key: "totalQuestions",
      label: "Total Questions",
      render: (row) => row.totalQuestions || 0,
    },

    {
      key: "fees",
      label: "Fees",
      render: (row) => `₹${row.testFees || 0}`,
    },

    // Question PDF
    {
      key: "questionPdf",
      label: "Question",
      render: (row) =>
        row?.questionFiles?.questionPdf ? (
          <a
            href={row.questionFiles.questionPdf}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FiFileText size={18} />
          </a>
        ) : (
          "N/A"
        ),
    },
  {
  key: "anser",
  label: "Answer",
  render: (row) => (
    <button
      style={{
        border: "none",
        background: "transparent",
        cursor: "pointer",
        fontSize: "14px",
        color: "#1976d2",          // blue color
        display: "flex",
        alignItems: "center",
        gap: "5px",
        fontWeight: "500"
      }}
        onClick={() => {
          const totalQuestions = row.totalQuestions || 0;
          const apiAnswers = row?.questionFiles?.answers || [];

          const omrAnswers = {};

          // Initialize with empty strings
          for (let i = 1; i <= totalQuestions; i++) {
            omrAnswers[i] = "";
          }

          // Populate with API answers
          apiAnswers.forEach((item) => {
            if (item.questionNumber && item.correctAnswer) {
              omrAnswers[item.questionNumber] = item.correctAnswer;
            }
          });

          console.log("Navigating to OMR with totalQuestions:", totalQuestions);
          console.log("Populated OMR Answers:", omrAnswers);

          localStorage.setItem("totalQuestions", totalQuestions.toString());
          localStorage.setItem("omrAnswers", JSON.stringify(omrAnswers));

          navigate("/omr/batches");
        }}
    >
      <FiEye size={16} />
    </button>
  ),
}
   
  ];

  // --- Filter Definitions ---
  const filters = [

  ];

  const handleFilterChange = (key, option) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [key]: option,
    }));
  };

  return (
    <div className="batch-list-page" style={{ padding: "20px" }}>
      <div style={{ marginBottom: "20px" }}>
        <h2>Total Batches</h2>
      </div>

      {loading ? (
       <TableSkeleton columns={getColumns()} rows={5} hasActions={true} />
      ) : (
        <DynamicTable
          columns={getColumns()}
          data={batches}
          filters={filters}
          search={search}
          setSearch={setSearch}
          selectedFilters={selectedFilters}
          handleFilterChange={handleFilterChange}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          onSearchClick={fetchBatchList}
          activeTab="All" // You can change this based on your logic
        />
      )}
    </div>
  );
};

export default TotalBatches;